export default __webpack_public_path__ + "static/media/spotify-logo.d41c150b.svg";